import { useGenericQuery } from '../../../core/api/reactQuery';
import { useFeedbackStore } from '../stores/feedbackStore';
import { getFeedback } from '../queries/feedback';

export function useFeedback(slug: string, tryNumber: number) {
  const { setFeedback } = useFeedbackStore()
  const { 
    data,
    isError, 
    error, 
    isSuccess, 
    isPending 
  } = useGenericQuery(['theme', slug, tryNumber], () => getFeedback(slug, tryNumber), setFeedback);

  return {
    data,
    isError,
    isPending,
    error,
    isSuccess,
  }
}
